"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.estimateTxFee = void 0;
var js_buildTransaction_1 = require("./js-buildTransaction");
var js_createTransaction_1 = __importDefault(require("./js-createTransaction"));
var utils_1 = require("./utils");
var logs_1 = require("@ledgerhq/logs");
function estimateTxFee(api, account, kind) {
    return __awaiter(this, void 0, void 0, function () {
        var tx, _a, onChainTx, fee;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    tx = createDummyTx(account, kind);
                    return [4 /*yield*/, (0, js_buildTransaction_1.buildTransactionWithAPI)(account, tx, api)];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 1]), onChainTx = _a[0];
                    return [4 /*yield*/, api.getFeeForMessage(onChainTx.compileMessage())];
                case 2:
                    fee = _b.sent();
                    if (typeof fee !== "number") {
                        (0, logs_1.log)("error", "api.getFeeForMessage returned invalid fee: <".concat(fee, ">"));
                        // TEMP HACK: sometimes fee is not a number, retrying with a next blockhash
                        return [2 /*return*/, retryWithNewBlockhash(api, onChainTx)];
                    }
                    return [2 /*return*/, fee];
            }
        });
    });
}
exports.estimateTxFee = estimateTxFee;
var createDummyTx = function (account, kind) {
    switch (kind) {
        case "transfer":
            return createDummyTransferTx(account);
        case "stake.createAccount":
            return createDummyStakeCreateAccountTx(account);
        case "stake.delegate":
            return createDummyStakeDelegateTx(account);
        case "stake.undelegate":
            return createDummyStakeUndelegateTx(account);
        case "stake.withdraw":
            return createDummyStakeWithdrawTx(account);
        case "stake.split":
        case "token.createATA":
        case "token.transfer":
            throw new Error("not implemented for <".concat(kind, ">"));
        default:
            return (0, utils_1.assertUnreachable)(kind);
    }
};
var createDummyTransferTx = function (account) {
    return __assign(__assign({}, (0, js_createTransaction_1["default"])({})), { model: {
            kind: "transfer",
            uiState: {},
            commandDescriptor: __assign({ command: {
                    kind: "transfer",
                    amount: 0,
                    recipient: account.freshAddress,
                    sender: account.freshAddress
                } }, commandDescriptorCommons)
        } });
};
var createDummyStakeCreateAccountTx = function (account) {
    return __assign(__assign({}, (0, js_createTransaction_1["default"])({})), { model: {
            kind: "stake.createAccount",
            uiState: {},
            commandDescriptor: __assign({ command: {
                    kind: "stake.createAccount",
                    amount: 0,
                    delegate: {
                        voteAccAddress: randomAddresses[0]
                    },
                    fromAccAddress: account.freshAddress,
                    seed: "",
                    stakeAccAddress: randomAddresses[1],
                    stakeAccRentExemptAmount: 0
                } }, commandDescriptorCommons)
        } });
};
var createDummyStakeDelegateTx = function (account) {
    return __assign(__assign({}, (0, js_createTransaction_1["default"])({})), { model: {
            kind: "stake.delegate",
            uiState: {},
            commandDescriptor: __assign({ command: {
                    kind: "stake.delegate",
                    authorizedAccAddr: account.freshAddress,
                    stakeAccAddr: randomAddresses[0],
                    voteAccAddr: randomAddresses[1]
                } }, commandDescriptorCommons)
        } });
};
var createDummyStakeUndelegateTx = function (account) {
    return __assign(__assign({}, (0, js_createTransaction_1["default"])({})), { model: {
            kind: "stake.undelegate",
            uiState: {},
            commandDescriptor: __assign({ command: {
                    kind: "stake.undelegate",
                    authorizedAccAddr: account.freshAddress,
                    stakeAccAddr: randomAddresses[0]
                } }, commandDescriptorCommons)
        } });
};
var createDummyStakeWithdrawTx = function (account) {
    return __assign(__assign({}, (0, js_createTransaction_1["default"])({})), { model: {
            kind: "stake.withdraw",
            uiState: {},
            commandDescriptor: __assign({ command: {
                    kind: "stake.withdraw",
                    amount: 0,
                    authorizedAccAddr: account.freshAddress,
                    stakeAccAddr: randomAddresses[0],
                    toAccAddr: randomAddresses[1]
                } }, commandDescriptorCommons)
        } });
};
var commandDescriptorCommons = {
    errors: {},
    fee: 0,
    warnings: {}
};
// pregenerate for better caching
var randomAddresses = [
    "HxCvgjSbF8HMt3fj8P3j49jmajNCMwKAqBu79HUDPtkM",
    "AjmMiagw33Ad4WdPR3y2QWsDXaLxmsiSZEpMfpT1Q9uZ",
    "AVHhsobqNw3b3XD43fz7Crq3d3UxFYZfHAByh7ogZoeN",
    "FvbvvXMY4Rf1AtGG7UHJUesjt8FFgPnPy6o83Dna9mXK",
    "AEtRo9MKfLqGtjvxdz8H93R7SQxXLEkibVSJbs9XKnD1",
];
function retryWithNewBlockhash(api, onChainTx) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, fee;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (onChainTx.recentBlockhash === undefined) {
                        throw new Error("expected recentBlockhash");
                    }
                    _a = onChainTx;
                    return [4 /*yield*/, waitNextBlockhash(api, onChainTx.recentBlockhash)];
                case 1:
                    _a.recentBlockhash = _b.sent();
                    return [4 /*yield*/, api.getFeeForMessage(onChainTx.compileMessage())];
                case 2:
                    fee = _b.sent();
                    if (typeof fee !== "number") {
                        throw new Error("unexpected fee: <".concat(fee, ">, after retry with a new blockhash"));
                    }
                    return [2 /*return*/, fee];
            }
        });
    });
}
function sleep(durationMS) {
    return new Promise(function (res) { return setTimeout(res, durationMS); });
}
function waitNextBlockhash(api, currentBlockhash) {
    return __awaiter(this, void 0, void 0, function () {
        var sleepTimeMS, i, blockhash;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sleepTimeMS = 5000;
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < 5)) return [3 /*break*/, 5];
                    (0, logs_1.log)("info", "sleeping for ".concat(sleepTimeMS, " ms, waiting for a new blockhash"));
                    return [4 /*yield*/, sleep(sleepTimeMS)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, api.getLatestBlockhash()];
                case 3:
                    blockhash = _a.sent();
                    if (blockhash !== currentBlockhash) {
                        (0, logs_1.log)("info", "got a new blockhash");
                        return [2 /*return*/, blockhash];
                    }
                    (0, logs_1.log)("info", "got same blockhash");
                    _a.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 1];
                case 5: throw new Error("next blockhash timeout");
            }
        });
    });
}
//# sourceMappingURL=tx-fees.js.map